import * as types from '../constants/patterns';

export const fetchPatternSummary = () => ({
    type: types.FETCH_PATTERN_SUMMARY_REQUEST
});

export const fetchPatterns = (params?: any) => ({
    type: types.FETCH_PATTERNS_REQUEST,
    payload: params
});

export const fetchPatternClaims = (patternId: string | number) => ({
    type: types.FETCH_PATTERN_CLAIMS_REQUEST,
    payload: patternId
});
